import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { TIMESHEET_CALENDAR } from "icons";

export function TimesheetNavigations() {
  return (
    <NavItem
      title="Timesheet"
      icon={TIMESHEET_CALENDAR}
      url="/timesheet"
      matchExact={true}
      defaultOpen={true}
    >
      <NavSubItem title="Plan" url="/timesheet/plan" />
      <NavSubItem title="Logs" url="/timesheet/logs" />
      <NavSubItem title="Draft" url="/timesheet/draft" />
      <NavSubItem title="Reviews" url="/timesheet/reviews" />
      <NavSubItem title="My Team" url="/timesheet/my-team" />
    </NavItem>
  );
}
